"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAlertContactService = exports.updateAlertsRecipientsService = exports.getRecipientsInformationsService = exports.getClientEligibilityRequestsService = exports.getClientRequestsService = exports.updateAppointmentService = exports.cancelAppointmentService = exports.bookAppointmentService = exports.fetchAppointmentService = void 0;
var index_1 = require("../index");
var axiosInstance_1 = __importDefault(require("../helper/axiosInstance"));
var common_1 = require("./common");
var appointments_1 = __importDefault(require("../models/appointments"));
var ClientRequest_1 = __importDefault(require("../models/ClientRequest"));
function fetchAppointmentService(workExecutionId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/work_order/".concat(workExecutionId, "/appointments");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.HISTORY_INTERVENTION).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    if ((response === null || response === void 0 ? void 0 : response.status) == 200) {
                        return [2 /*return*/, new appointments_1.default(response.data)];
                    }
                    else if ((response === null || response === void 0 ? void 0 : response.status) == 204) {
                        return [2 /*return*/, new appointments_1.default({ workexecutionId: workExecutionId, slots: [] })];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.fetchAppointmentService = fetchAppointmentService;
function bookAppointmentService(workExecutionId, appointment, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL, "/users/intervention/work_order/").concat(workExecutionId, "/appointments");
                    body = JSON.stringify(appointment);
                    return [4 /*yield*/, axiosInstance_1.default.post(route, body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.status];
            }
        });
    });
}
exports.bookAppointmentService = bookAppointmentService;
function cancelAppointmentService(workExecutionId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL, "/users/intervention/work_order/").concat(workExecutionId, "/appointments/cancel");
                    return [4 /*yield*/, axiosInstance_1.default.delete(route, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.status];
            }
        });
    });
}
exports.cancelAppointmentService = cancelAppointmentService;
function updateAppointmentService(workExecutionId, appointment, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL, "/users/intervention/work_order/").concat(workExecutionId, "/appointments");
                    body = JSON.stringify(appointment);
                    return [4 /*yield*/, axiosInstance_1.default.put(route, body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.status];
            }
        });
    });
}
exports.updateAppointmentService = updateAppointmentService;
function getClientRequestsService(clientId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/clients/".concat(clientId, "/requests");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    if ((response === null || response === void 0 ? void 0 : response.status) == 200) {
                        return [2 /*return*/, response.data.requests.map(function (d) { return new ClientRequest_1.default(d); })];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.getClientRequestsService = getClientRequestsService;
function getClientEligibilityRequestsService(clientId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/clients/".concat(clientId, "/requests/eligibility");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
            }
        });
    });
}
exports.getClientEligibilityRequestsService = getClientEligibilityRequestsService;
function getRecipientsInformationsService(clientId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/clients/".concat(clientId, "/alerts/contacts");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
            }
        });
    });
}
exports.getRecipientsInformationsService = getRecipientsInformationsService;
function updateAlertsRecipientsService(clientId, sectionSubscriptionId, contacts, token, origin) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    if (origin) {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token),
                                Origin: origin
                            }
                        };
                    }
                    else {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token),
                            }
                        };
                    }
                    route = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL, "/users/clients/").concat(clientId, "/section_subscriptions/").concat(sectionSubscriptionId, "/alerts/contacts");
                    body = JSON.stringify(contacts);
                    return [4 /*yield*/, axiosInstance_1.default.post(route, body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.updateAlertsRecipientsService = updateAlertsRecipientsService;
function validateAlertContactService(token) {
    return __awaiter(this, void 0, void 0, function () {
        var route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values) {
                        throw Error('No urls config found');
                    }
                    route = "/v1.1/alerts/contacts?token=".concat(token);
                    return [4 /*yield*/, axiosInstance_1.default.put("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), {}, {})];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.status];
            }
        });
    });
}
exports.validateAlertContactService = validateAlertContactService;
